<template>
  <div
    v-loading="statusLoading"
    class="switch-card switch-card--double"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 头部：别名 + 类型标识 + 工具 -->
    <div class="switch-card__header">
      <div class="switch-card__identity">
        <el-tooltip :content="switchInfo.alias" placement="top">
          <span class="switch-card__name">{{ switchInfo.alias }}</span>
        </el-tooltip>
        <span class="switch-card__type-tag">双组开关</span>
      </div>
      <div class="switch-card__tools">
        <el-tooltip content="刷新状态" placement="top">
          <el-button
            class="switch-card__tool-btn"
            size="mini"
            circle
            icon="el-icon-refresh-right"
            @click="handleRefresh(item)"
          />
        </el-tooltip>
        <!-- <el-tooltip content="编辑" placement="top">
          <el-button
            class="switch-card__tool-btn"
            size="mini"
            circle
            icon="el-icon-edit"
            @click="openEditDialog"
          />
        </el-tooltip> -->
        <el-tooltip content="删除开关" placement="top">
          <el-button
            class="switch-card__tool-btn switch-card__tool-btn--danger"
            size="mini"
            circle
            icon="el-icon-delete"
            @click="handleDelete(item)"
          />
        </el-tooltip>
      </div>
    </div>

    <!-- 双组开关 -->
    <div class="switch-card__groups">
      <div
        v-for="(group, index) in switchInfo.groups"
        :key="`${group.id}-${index}`"
        :class="`is-${group.status}`"
        class="switch-group"
      >
        <div class="switch-group__head">
          <el-tooltip :content="group.name" placement="top">
            <span class="switch-group__name">{{ group.name }}</span>
          </el-tooltip>
          <span class="switch-group__address">地址 {{ group.address }}</span>
        </div>

        <div class="switch-group__status">
          <span
            class="switch-group__lamp"
            :class="`is-${group.status}`"
          />
          <span
            class="switch-group__status-label"
            :class="`is-${group.status}`"
          >{{ statusText(group.status) }}</span>
        </div>

        <div class="switch-group__actions">
          <el-button
            type="success"
            size="mini"
            round
            :disabled="group.status === 'open'"
            @click="handleOperate(index, 1)"
          >操作分闸</el-button>
          <el-button
            type="danger"
            size="mini"
            round
            :disabled="group.status === 'close'"
            @click="handleOperate(index, 2)"
          >操作合闸</el-button>
        </div>
      </div>
    </div>

    <!-- 双组开关卡片的采集器编号 -->
    <div class="switch-card__meta">
      <div class="switch-card__meta-row">
        <span class="switch-card__meta-label">采集器编号</span>
        <span class="switch-card__meta-value">{{ switchInfo.gatewaySn }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/** 开关状态字典 */
const STATUS_DICT = {
  /** 合闸 */
  close: { label: '合闸' },
  /** 分闸 */
  open: { label: '分闸' },
  /** 离线 */
  offline: { label: '离线' }
}
import { QueryChannelStatusAndIndicatorStatus, ChannelFlashOpen } from '@/api/SwitchDevice'
export default ({
  name: 'DoubleSwitch',
  props: {
    switchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      /** 刷新状态loading */
      statusLoading: false,
      /** 操作loading */
      operateLoading: false,
    }
  },
  methods: {
    /** 状态文案 */
    statusText (status) {
      const dict = STATUS_DICT[status]
      return dict ? dict.label : status
    },

    /** 刷新开关状态 */
    handleRefresh () {
      this.statusLoading = true
      QueryChannelStatusAndIndicatorStatus({
        deviceid: this.switchInfo.deviceid,
        address: '1',
        controlIndex: '2',
        deviceModel: 'io4',
        sn: this.switchInfo.gatewaySn
      }).then(({ data }) => {
        // indicator:指示灯状态
        const { indicator } = data
        if (indicator.status === '0' && indicator.data.code === '0') {
          const { do1, do2, do3, do4 } = indicator.data.data
          if ((do1 === true && do2 === true && do3 === true && do4 === true) || (do1 === false && do2 === false && do3 === false && do4 === false)) {
            this.switchInfo.groups[0].status = 'offline'
            this.$message({
              message: '刷新状态失败',
              type: 'error'
            })
          } else {
            if (do1 === true) {
              this.switchInfo.groups[0].status = 'open'
            } else if (do2 === true) {
              this.switchInfo.groups[0].status = 'close'
            }
            if (do3 === true) {
              this.switchInfo.groups[1].status = 'open'
            } else if (do4 === true) {
              this.switchInfo.groups[1].status = 'close'
            }
            this.$message({
              message: '刷新状态成功',
              type: 'success'
            })
          }
        } else {
          this.switchInfo.groups[0].status = 'offline'
          this.$message({
            message: '刷新状态失败',
            type: 'error'
          })
        }
        return data
      }).then(() => {
        this.statusLoading = false
      }).catch(() => {
        this.statusLoading = false
        this.$message({
          message: '刷新状态失败',
          type: 'error'
        })
      })
    },

    /** 删除开关 */
    handleDelete () {
      this.$emit('deleteSwitch', this.switchInfo)
    },

    /**
     * 执行某一组开关操作前的状态预检
     * @param groupIndex 分组索引 0=分组1 1=分组2
     * @param operateType 1=分组1分闸 2=分组1合闸 3=分组2分闸 4=分组2合闸
     */
    handleOperate (groupIndex, operateType) {
      // 离线状态不允许操作，提示刷新
      if (this.switchInfo.groups[groupIndex].status === 'offline') {
        this.$msgWarning(`「${this.switchInfo.alias}-${this.switchInfo.groups[groupIndex].name}」当前处于离线状态，请尝试刷新状态后再执行此操作`)
      } else {
        if (operateType === '1' && this.switchInfo.groups[groupIndex].status === 'open') {
          this.$msgWarning(`「${this.switchInfo.alias}-${this.switchInfo.groups[groupIndex].name}」当前已分闸，无需重复操作`)
        } else if (operateType === '2' && this.switchInfo.groups[groupIndex].status === 'close') {
          this.$msgWarning(`「${this.switchInfo.alias}-${this.switchInfo.groups[groupIndex].name}」当前已合闸，无需重复操作`)
        } else {
          this.currentOperate.operateType = operateType
          this.currentOperate.groupIndex = `${groupIndex}`
          this.$emit('operateSwitchValidate', this.switchInfo, groupIndex, operateType)
        }
      }
    },
    /** 操作码校验通过后执行操作 */
    handleOperateConfirmCall () {
      return new Promise((resolve, reject) => {
        const { operateType, groupIndex } = this.currentOperate
        if (!operateType || !groupIndex) {
          reject('操作参数错误')
        }
        const operateTxt = operateType === '1' ? '分闸' : '合闸'
        this.loadingtxt = `正在${operateTxt}，操作中`
        this.operateLoading = true
        let controlIndex
        if (groupIndex === '0') {
          controlIndex = operateType
        } else {
          controlIndex = operateType + 2
        }
        ChannelFlashOpen({
          sn: this.switchInfo.gatewaySn,
          address: '1',
          controlIndex: controlIndex,
          deviceModel: 'io4',
        }).then((response) => {
          const { status, data } = response
          if (status === '0') {
            if (data.code === '0') {
              window.setTimeout(() => { this.handleRefresh() }, 1000)
              this.currentOperate.operateType = ''
              resolve()
            } else {
              this.$message({
                message: `操作${operateTxt}失败`,
                type: 'error'
              })
              reject(`操作${operateTxt}失败`)
            }
          } else {
            this.$message({
              message: `操作${operateTxt}失败`,
              type: 'error'
            })
            reject(`操作${operateTxt}失败`)
          }
        }).catch(() => {
          this.$message({
            message: `操作${operateTxt}失败`,
            type: 'error'
          })
          reject(`操作${operateTxt}失败`)
        }).finally(() => {
          this.operateLoading = false
          this.loadingTxt = ""
        })
      })
    }
  }
})
</script>
